import * as React from 'react';
import { connect } from 'react-redux';

import * as moment from 'moment';

import TooltipItem from '../TooltipItem/TooltipItem';
import { currentEvent$ } from '../../selectors/userExplorer';
import * as UserExplorerActions from '../../actions/userExplorer';

import State from '../../interfaces/states/State';

import './style.scss';

interface DispatchProps {
  currentEventActions: (category: string, label: string) => void;
}

interface OwnProps {
  timestamp: string;
  event: string;
  category: string;
  currentEvent: any;
}

interface Props extends DispatchProps, OwnProps {}

function UserExplorerItem (props: Props) {

  const getTooltip = React.useCallback(() => {
    props.currentEventActions(props.category, props.event);
  }, [props.currentEventActions, props.category, props.event]);

  const {
    event,
    category,
    timestamp,
    currentEvent,
  } = props;

  return(
    <div className='user-explorer-item d-flex'>
      <div className='user-explorer-event'>{category}</div>
      <div
        onMouseEnter={getTooltip}
        className='user-explorer-event cursor-pointer'>
        <TooltipItem
          title={undefined !== currentEvent ? currentEvent.description : ''}>
          <span>{event}</span>
        </TooltipItem>
      </div>
      <div className='d-flex flex-column align-flex-end justify-center user-explorer-date'>
        <div className=''>{moment(timestamp).format('YYYY MMM DD')}</div>
        <div className='gray'>{moment(timestamp).format('HH:mm:ss')}</div>
      </div>
    </div>
  );
  
}

const mapStateToProps = (state: State) => {
  return {
    currentEvent: currentEvent$(state)[0],
  };
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps) => {
  return {
    ...stateProps,
    currentEventActions: dispatchProps.currentEventActions,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    currentEventActions: UserExplorerActions.fetchUserExplorerCurrentEventAction,
  }, mergeProps
)(React.memo(UserExplorerItem));
